<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Text</h1>
        <p>Documentation and examples for common text utilities to control alignment, wrapping, weight, and more.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">A few Examples</p>
            <p class="text-justify">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
            <p class="text-left">Left aligned text on all viewport sizes.</p>
            <p class="text-center">Center aligned text on all viewport sizes.</p>
            <p class="text-right">Right aligned text on all viewport sizes.</p>
            <p class="font-weight-bold">Bold text.</p>
            <p class="font-weight-normal">Normal weight text.</p>
            <p class="font-italic">Italic text.</p>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt; ... class="text-justify"&gt;
&lt; ... class="text-left"&gt;
&lt; ... class="text-center"&gt;
&lt; ... class="text-right"&gt;

&lt; ... class="font-weight-bold"&gt;
&lt; ... class="font-weight-normal"&gt;
&lt; ... class="font-italic"&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">

            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">Variants / Modifiers</p>   
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p class="h4">Text alignment</p>
                <p>Easily realign text to components with text alignment classes.</p>
                <p>For left, right, and center alignment, responsive classes are available that use the same viewport width breakpoints as the grid system <span class="code">text-{size}-{align}</span> for <span class="code">sm</span>, <span class="code">md</span>, <span class="code">lg</span>, and <span class="code">xl</span>.</p>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col">
                <p class="h4">Text wrapping and overflow</p>
                <p>Prevent text from wrapping with a <span class="code">.text-nowrap</span> class.</p>
                <p>For longer content, you can add a <span class="code">.text-truncate</span> class to truncate the text with an ellipsis. <b>Requires <span class="code">display: inline-block</span> or <span class="code">display: block</span>.</b></p>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p class="h4">Text transform</p>
                <p>Transform text in components with text capitalization classes.</p>
                <p>Note how <span class="code">text-capitalize</span> only changes the first letter of each word, leaving the case of any other letters unaffected.</p>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <p class="h4">Font weight and italics</p>
                <p>Quickly change the weight (boldness) of text or italicize text.</p>
              </div>
            </div>
            
            
          </div>
        </div>
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Text"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Text.vue